import * as React from "react";
import { useRifm } from "rifm";
import { formatZipCode } from "@nju/utils";
import { Input, InputStyleProps } from "../Input";

const postCodeFormat = (value: string) => {
  return formatZipCode(value, "-");
};

interface IPostCodeFieldProps extends InputStyleProps {
  onValueChange?: (value: string) => void;
  defaultValue?: string;
  label?: string;
}

export function PostCodeField({
  onValueChange,
  defaultValue = "",
  label = "kod pocztowy",
  state,
}: IPostCodeFieldProps) {
  const [value, setValue] = React.useState(defaultValue);

  const rifm = useRifm({
    value,
    onChange: setValue,
    format: postCodeFormat,
  });

  React.useEffect(() => {
    if (onValueChange) {
      onValueChange(value);
    }
  }, [value, onValueChange]);

  return (
    <Input
      defaultValue={defaultValue}
      label={label}
      name="postCode"
      onChange={rifm.onChange}
      state={state}
      value={rifm.value}
    />
  );
}
